export const environment = {
    alias: 'referentka-dev',
    firebaseProject: 'referentka-11e99',
    sentryDsn:
        'https://c64e0f6f0b033b8d5eb33c6ecbfa1f29@o4508794559070208.ingest.de.sentry.io/4508794602782800',
};
